// extracted by mini-css-extract-plugin
module.exports = {"summary__stats":"G_ct","summary__stats__links":"G_cv","summary__stats__links__single":"G_cw"};